import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusCurrentColor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z",
		fill: "currentColor"
	})
});
export default SvgPlusCurrentColor;
